import React from 'react'
import { Link } from 'react-router-dom'
import useDeviceDetect from 'components/DeviceDetect'
import {
  OftenBuyContainer,
  OftenBuyTitle,
  OftenBuyContent,
  OftenBuyProducts,
  OftenBuyProductItems,
  OftenBuyProductNames,
  OftenBuySummery,
  OftenBuyRightSide,
  OftenBuyPrice,
} from './OftenBuy.style'
import { Basket, Check } from 'components/Icons'
import Button from 'components/Button'
import ProductItem from 'components/Widgets/ProductItem'
import getProductUrl from 'helpers/getProductUrl'
import useCart from 'store/CartProvider'
import { useEffect, useState } from 'react'

const OftenBuy = props => {
  const {
    products: { products },
    product,
  } = props
  const [skus, setSkus] = useState([])
  const { addToCart } = useCart()
  const { isBrowser } = useDeviceDetect()

  const toggleProduct = (sku, active) => {
    let sks = [...skus]
    let ind = sks.indexOf(sku)
    if (ind > -1) {
      sks.splice(ind, 1)
    } else {
      sks.push(sku)
    }

    setSkus(sks)
  }

  useEffect(() => {
    if (!products || !Array.isArray(products) || !products.length) return
    setSkus([product.sku, ...products.map(p => p.sku)])
  }, [products, product.sku])

  if (!Array.isArray(products)) return null

  const sum =
    products.reduce((acc, pr) => {
      if (skus.indexOf(pr.sku) === -1) return acc
      acc += pr.price
      return acc
    }, 0) + product.price

  return (
    <OftenBuyContainer>
      <OftenBuyTitle>ხშირად ყიდულობენ ერთად:</OftenBuyTitle>
      <OftenBuyContent>
        <OftenBuyProducts>
          <OftenBuyProductItems>
            <ProductItem
              nohover
              onlyPictureandPrice={!isBrowser}
              item={{
                price: product.price,
                prevPrice: product.old_price,
                name: product.name,
                sku: product.sku,
                image: product.image,
                url: getProductUrl(product.slug),
                star: Math.round(product.rating / 2),
              }}
            />
            {products.map((pr, i) => {
              if (i < 2) {
                return (
                  <ProductItem
                    key={pr.id}
                    nohover
                    onlyPictureandPrice={!isBrowser}
                    item={{
                      price: pr.price,
                      prevPrice: pr.old_price,
                      sku: pr.sku,
                      name: pr.name,
                      image: pr.image,
                      url: pr.slug ? getProductUrl(pr.slug) : '/',
                      star: Math.round(pr.rating / 2),
                    }}
                  />
                )
              }
              return null
            })}
          </OftenBuyProductItems>
        </OftenBuyProducts>
        <OftenBuyRightSide>
          <OftenBuyProductNames>
            <a href="##">
              <i className="check">
                <Check width={'15px'} height={'15px'} />
              </i>
              ეს პროდუქტი: {product.name || ''}
            </a>
            {products.map(pr => (
              <a
                onClick={e => {
                  e.preventDefault()
                  toggleProduct(pr.sku)
                }}
                href="##"
              >
                <i className="check">
                  <Check
                    checked={skus.indexOf(pr.sku) > -1}
                    width="15px"
                    height="15px"
                  />
                </i>
                <Link key={pr.id} to={getProductUrl(pr.slug)}>
                  {pr.name || ''}
                </Link>
              </a>
            ))}
          </OftenBuyProductNames>
          <OftenBuySummery>
            <OftenBuyPrice>
              <p>ფასი:</p>
              {sum && <h3>{sum}₾</h3>}
            </OftenBuyPrice>
            <Button
              style={{ width: '250px' }}
              color="orange"
              onClick={() => addToCart(skus, {}, true)}
            >
              <Basket color="white" width="15.01" height="20.41" />
              კალათაში დამატება
            </Button>
          </OftenBuySummery>
        </OftenBuyRightSide>
      </OftenBuyContent>
    </OftenBuyContainer>
  )
}

export default OftenBuy
